:host {
  display: block;
}
.qumra-search-button{
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  height: 45px;
  width: 45px;
  border-radius: 99999999px; ;
}

.search-popup {
  position: fixed;
  width: 100vw;
  display: flex;
  align-items: center; 
  z-index: 10;
  justify-content: center;
  
}

.qumra-w-full{
  width: 100%;
}